
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import InvestorPortal from "./pages/InvestorPortal";
import AdminPortal from "./pages/AdminPortal";
import AboutLandContracts from "./pages/AboutLandContracts";
import DueDiligence from "./pages/DueDiligence";
import WhyInvestInLandContracts from "./pages/WhyInvestInLandContracts";
import ContractsVsRental from "./pages/ContractsVsRental";
import InvestmentDetails from "./pages/InvestmentDetails";
import NoteInvestingEducation from "./pages/NoteInvestingEducation";
import InvestorSalesPitch from "./pages/InvestorSalesPitch";
import NotFound from "./pages/NotFound";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/investor-portal" element={<InvestorPortal />} />
          <Route path="/admin-portal/*" element={<AdminPortal />} />
          <Route path="/investment/:id" element={<InvestmentDetails />} />
          
          {/* Marketing pages - commented out for CRM focus, can be restored later */}
          {/* <Route path="/about-land-contracts" element={<AboutLandContracts />} /> */}
          {/* <Route path="/due-diligence" element={<DueDiligence />} /> */}
          {/* <Route path="/why-invest-in-land-contracts" element={<WhyInvestInLandContracts />} /> */}
          {/* <Route path="/contracts-vs-rental" element={<ContractsVsRental />} /> */}
          {/* <Route path="/note-investing-education" element={<NoteInvestingEducation />} /> */}
          {/* <Route path="/investor-sales-pitch" element={<InvestorSalesPitch />} /> */}
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
